export default __webpack_public_path__ + "static/media/video_green.a6fa1192.svg";